'use client';

import { cn } from '@/lib/utils';
import { icons, LucideIcon, LucideProps } from 'lucide-react';
import { HTMLAttributes } from 'react';

export type IconsComponent = typeof icons & Record<string, LucideIcon>;
export const iconsComponent: IconsComponent = icons;

export const createIconsOptions = (
    props: LucideProps,
    wrapperProps?: HTMLAttributes<HTMLDivElement>,
    hideName?: boolean
) => {
    return Object.keys(iconsComponent).map((x) => {
        const Component = iconsComponent[x];
        return {
            label: (
                <div
                    {...wrapperProps}
                    className={cn(
                        'flex w-full items-center gap-x-2',
                        wrapperProps?.className
                    )}
                >
                    <Component {...props} /> {hideName ? '' : <span>{x}</span>}
                </div>
            ),
            value: x,
        };
    });
};

export type LucideIconName = keyof typeof icons;
export type LucideCustomProps = LucideProps & {
    iconName?: LucideIconName;
    rawName?: string;
    priorityPropName?: 'iconName' | 'rawName';
    title?: string;
};
export const LucideCustom = ({
    iconName,
    rawName,
    priorityPropName,
    title,
    ...props
}: LucideCustomProps) => {
    const name =
        iconName && rawName
            ? priorityPropName
                ? priorityPropName === 'iconName'
                    ? iconName
                    : priorityPropName === 'rawName'
                      ? rawName
                      : (iconName ?? rawName)
                : (iconName ?? rawName)
            : iconName
              ? iconName
              : rawName;

    const Component =
        iconsComponent[name as LucideIconName] ??
        iconsComponent[iconName as LucideIconName];
    return Component ? (
        <span aria-labelledby={title} title={title}>
            <Component size={15} {...props} />
        </span>
    ) : (
        <></>
    );
};

export default LucideCustom;
